import React from 'react';
import { SectionHeading } from './SectionHeading';
import { differenceHighlights, differenceParagraphs } from '../data/landing';
export function DifferenceSection() {
  return <section aria-labelledby="diferencia" className="bg-stone-50" data-id="element-60" data-mp="1p1qjbc387q88">
      
    </section>;
}